"use client";

import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Cookie, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import LegalModal from './LegalModals';

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [legalModal, setLegalModal] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie-consent');
    if (!consent) {
      const timer = setTimeout(() => setIsVisible(true), 2000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookie-consent', 'accepted');
    setIsVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookie-consent', 'declined');
    setIsVisible(false);
  };

  return (
    <>
      <AnimatePresence>
        {isVisible && (
          <motion.div
            initial={{ y: 100, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: 100, opacity: 0 }}
            className="fixed bottom-6 left-6 right-6 md:left-auto md:right-6 md:max-w-md z-[200]"
          >
            <div className="bg-slate-900/90 border border-white/10 backdrop-blur-2xl p-6 rounded-[2rem] shadow-2xl">
              <div className="flex items-start gap-4 mb-4">
                <div className="w-10 h-10 rounded-full bg-fuchsia-500/20 flex items-center justify-center shrink-0">
                  <Cookie className="w-5 h-5 text-fuchsia-500" />
                </div>
                <div className="flex-1">
                  <h3 className="text-white font-bold mb-1">Cookie Settings</h3>
                  <p className="text-slate-400 text-sm leading-relaxed">
                    We use cookies to enhance your experience. By continuing to visit this site you agree to our use of cookies.
                  </p>
                </div>
                <button 
                  onClick={() => setIsVisible(false)}
                  className="text-slate-500 hover:text-white transition-colors"
                  aria-label="Close"
                >
                  <X className="w-5 h-5" />
                </button>
              </div>

              <div className="flex flex-col sm:flex-row gap-3">
                <Button 
                  onClick={handleAccept}
                  className="flex-1 bg-fuchsia-600 hover:bg-fuchsia-700 text-white rounded-xl font-bold"
                >
                  Accept All
                </Button>
                <Button 
                  variant="outline"
                  onClick={() => setLegalModal(true)}
                  className="flex-1 border-white/10 text-slate-300 hover:bg-white/5 rounded-xl"
                >
                  Learn More
                </Button>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      <LegalModal 
        isOpen={legalModal} 
        onClose={() => setLegalModal(false)} 
        type="cookies" 
      />
    </>
  );
};

export default CookieConsent;